import React, { Component } from "react";
import {
  Card,
  Badge,
  CardBody,
  CardTitle,
  ButtonDropdown,
  CustomInput,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { connect } from "react-redux";
import {
  setContainerClassnames,
  clickOnMobileMenu,
} from "../../../redux/actions";
import IntlMessages from "../../../helpers/IntlMessages";
import classnames from "classnames";
import { END_POINT } from "../../../constants/defaultValues";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import { AddCommaNumber } from "../../../helpers/Utils";
import ProductImage from "../../../components/common/ProductImage";
import {
  buildOrderVariantBadges,
  getOrderVariantSignature,
} from "../../../helpers/OrderVariantBadges";
import { getFeeOtherLabelMessageId } from "../../../helpers/FeeOtherLabel";

class LabelItemLeft extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownSplitOpen: false,
    };
  }

  toggleSplit = () => {
    this.setState((prevState) => ({
      dropdownSplitOpen: !prevState.dropdownSplitOpen,
    }));
  };

  menuButtonClick = (e, menuClickCount, containerClassnames) => {
    setTimeout(() => {
      var event = document.createEvent("HTMLEvents");
      event.initEvent("resize", false, false);
      window.dispatchEvent(event);
    }, 350);
    this.props.setContainerClassnames(
      menuClickCount,
      containerClassnames,
      this.props.selectedMenuHasSubItems
    );
  };

  onClickedItem = (item) => {
    // console.log('item: ', item);
    this.props.onClickedItem(
      // callback
      item,
      this.menuButtonClick,
      [null, 1000, this.props.containerClassnames]
    );
  };

  render() {
    const { dropdownSplitOpen } = this.state;
    const {
      item,
      setting,
      selectedItems,
      idx,
      onChangeCheckbox,
      isDisabledDelete,
      onDeleteBill,
    } = this.props;

    return (
      item.data.length && (
        <Card
          className="mb-3 custom-shadow"
          onClick={() => {
            this.onClickedItem(item);
          }}
        >
          <div className="position-absolute card-top-buttons custom-inline">
            <div className="custom-control custom-checkbox pl-1 align-self-center pr-4">
              <ButtonDropdown
                isOpen={dropdownSplitOpen}
                toggle={this.toggleSplit}
                onClick={(e) => e.stopPropagation()}
                // onClick={() => this.onClickedItem(item)}
              >
                <div
                  // className='cursor-pointer btn btn-lg btn-primary pl-4 pr-0 check-button check-all'
                  className={classnames(
                    "btn btn-lg btn-secondary pl-4 pr-0 check-button check-all",
                    {
                      "btn-primary": selectedItems.includes(item.pin),
                    }
                  )}
                >
                  <CustomInput
                    className="custom-checkbox mb-0 d-inline-block"
                    type="checkbox"
                    id={idx}
                    checked={selectedItems.includes(item.pin)}
                    onChange={() => onChangeCheckbox(item.pin)}
                    label={<span className={`custom-control-label`} />}
                  />
                </div>
                <DropdownToggle
                  caret
                  color={
                    selectedItems.includes(item.pin) || dropdownSplitOpen
                      ? "primary"
                      : "secondary"
                  }
                  className="dropdown-toggle-split"
                  onClick={() => onChangeCheckbox(item.pin)}
                />
                <DropdownMenu right>
                  <DropdownItem
                    className={classnames("text-left red", {
                      disable: isDisabledDelete,
                    })}
                    onClick={() =>
                      isDisabledDelete ? null : onDeleteBill(item.pin)
                    }
                  >
                    <>
                      <i className="simple-icon-trash pr-2" />
                      Hủy hóa đơn
                    </>
                  </DropdownItem>
                </DropdownMenu>
              </ButtonDropdown>
            </div>
          </div>
          <CardBody className="p-3">
            <CardTitle className="mb-0">
              {item.data[0].pin_print ? (
                <Badge color="primary" pill>
                  Mã hoá đơn - #{item.data[0].pin_print}
                </Badge>
              ) : (
                <Badge color="secondary" pill>
                  Chưa in hoá đơn
                </Badge>
              )}
              {item.data[0].bill?.shippingOrder && (
                <Badge color="info" pill className="ml-1">
                  Ship: {item.data[0].bill.shippingOrder.tracking_code} -{" "}
                  {item.data[0].bill.shippingOrder.status_text ||
                    item.data[0].bill.shippingOrder.status}
                </Badge>
              )}
            </CardTitle>

            {(() => {
              const consolidatedData = [];
              if (item.data && item.data.length) {
                item.data.forEach((order) => {
                  if (!order) return;
                  const productName =
                    order.product?.name || order.name || order.product_name || "";
                  const optionSignature = getOrderVariantSignature(order);
                  const noteSignature = order.note || "";
                  const existing = consolidatedData.find(
                    (g) => {
                      const groupedProductName =
                        g.product?.name || g.name || g.product_name || "";
                      return (
                        groupedProductName === productName &&
                        Number(g.price) === Number(order.price) &&
                        getOrderVariantSignature(g) === optionSignature &&
                        (g.note || "") === noteSignature
                      );
                    }
                  );
                  const count = order.count || 1;
                  if (existing) {
                    existing.count += count;
                  } else {
                    consolidatedData.push({ ...order, count });
                  }
                });
              }
              return consolidatedData.map((order, idx) => {
                const variantBadges = buildOrderVariantBadges(order);
                const unitPrice = Number(order.price || 0);
                const totalPrice = unitPrice * Number(order.count || 1);
                const productName =
                  order.product?.name || order.name || order.product_name || "";

                return (
                  <Colxx xxs="12" key={idx} className="p-0 mt-3">
                    <span className={classnames("d-flex flex-row")}>
                      <ProductImage
                        image={order.product?.image}
                        alt={productName}
                        fnbType={order.product?.fnb_type}
                        className="list-thumbnail responsive border-0"
                        iconSize="40px"
                        style={{ objectFit: "cover" }}
                      />
                      <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                        <div
                          className={classnames(
                            "card-body p-2 align-items-center d-flex flex-ssm-column justify-content-between min-width-zero",
                            {
                              "flex-lg-row align-items-lg-center":
                                !setting.update,
                            }
                          )}
                          style={{ flexWrap: "wrap" }}
                        >
                          <div className="flex-grow-1 min-width-zero pr-2">
                            <p className="w-100 list-item-heading mb-1 truncate d-block">
                              {productName} · {AddCommaNumber(unitPrice)} đ{" "}
                              {order.count > 1 ? `(x${order.count})` : ""}
                            </p>
                            {variantBadges.length ? (
                              <div className="mb-1">
                                {variantBadges.map((badge, badgeIdx) => (
                                  <Badge
                                    key={`${badge}-${badgeIdx}`}
                                    color="primary"
                                    pill
                                    className="mr-1 mb-1"
                                  >
                                    {badge}
                                  </Badge>
                                ))}
                              </div>
                            ) : null}
                            {order.note ? (
                              <Badge color="success" pill className="mr-1 mb-1">
                                {order.note}
                              </Badge>
                            ) : null}
                            <p className="mb-1 text-muted text-small w-100 w-sm-100">
                              {order.date + " - " + order.time}
                            </p>
                          </div>
                          {/* <div
                            className="text-right flex-shrink-0"
                            style={{ minWidth: "92px" }}
                          >
                            <div className="font-weight-bold">
                              {AddCommaNumber(totalPrice)} đ
                            </div>
                            {order.count > 1 ? (
                              <div className="text-muted text-small">
                                Tổng {order.count} món
                              </div>
                            ) : null}
                          </div> */}
                          <div className="w-100 w-sm-100 mt-1">
                            {order.discount ? (
                              <Badge
                                className="mb-1 mr-1"
                                color="secondary"
                                pill
                              >
                                {"Chiết khấu: " +
                                  DiscountRender(order.discount)}
                              </Badge>
                            ) : (
                              ""
                            )}
                            {order.tax_fee ? (
                              <Badge
                                className="mb-1 mr-1"
                                color="secondary"
                                pill
                              >
                                {"Thuế: " + DiscountRender(order.tax_fee)}
                              </Badge>
                            ) : (
                              ""
                            )}
                            {order.fee_other ? (
                              <Badge
                                className="mb-1 mr-1"
                                color="secondary"
                                pill
                              >
                                <IntlMessages
                                  id={getFeeOtherLabelMessageId(
                                    order.fee_other,
                                  )}
                                />
                                {`: ${DiscountRender(order.fee_other)}`}
                              </Badge>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </span>
                  </Colxx>
                );
              });
            })()}
          </CardBody>
        </Card>
      )
    );
  }
}

const DiscountRender = (discount) => {
  return discount?.type === "price"
    ? AddCommaNumber(Math.round(discount?.value)) + " đ"
    : discount?.value + " %";
};

const mapStateToProps = ({ menu }) => {
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  return {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
  };
};
export default connect(mapStateToProps, {
  setContainerClassnames,
  clickOnMobileMenu,
})(LabelItemLeft);
